import { render, staticRenderFns } from "./SupplierEventProductUploadModal.vue?vue&type=template&id=ba72c13c&"
import script from "./SupplierEventProductUploadModal.vue?vue&type=script&lang=ts&"
export * from "./SupplierEventProductUploadModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports